var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Switch, Typography, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEditController } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { TimeZonePicker } from "@/components/timezones/TimeZonePicker";
import { DEFAULT_TIME_ZONE } from "@/lib/timezones/zonedFormat";
import { ELanguageDetectionPolicy, getDefaultLanguageDetectionPolicy, getLanguages, } from "@sequentech/ui-core";
var SettingsLanguagesStyles = {
    Wrapper: styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: column;\n    "], ["\n        display: flex;\n        flex-direction: column;\n    "]))),
    Content: styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        display: flex;\n        width: 239px;\n        align-items: center;\n        justify-content: space-between;\n    "], ["\n        display: flex;\n        width: 239px;\n        align-items: center;\n        justify-content: space-between;\n    "]))),
    Text: styled("span")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        text-transform: capitalize;\n    "], ["\n        text-transform: capitalize;\n    "]))),
};
export var SettingsLanguages = function () {
    var _a, _b, _c, _d, _e;
    var tenantId = useTenantStore()[0];
    var _f = useTranslation(), t = _f.t, i18n = _f.i18n;
    var listLangs = getLanguages(i18n);
    var _g = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _g.record, save = _g.save, isLoading = _g.isLoading;
    var defaultLanguageConf = {
        enabled_language_codes: ["en"],
        default_language_code: "en",
        language_detection_policy: getDefaultLanguageDetectionPolicy(),
    };
    var _h = useState((_b = (_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.language_conf) !== null && _b !== void 0 ? _b : defaultLanguageConf), languageConf = _h[0], setLanguageConf = _h[1];
    var _j = useState((_c = languageConf.default_language_code) !== null && _c !== void 0 ? _c : "en"), defaultLanguage = _j[0], setDefaultLanguage = _j[1];
    var _k = useState((_d = languageConf.language_detection_policy) !== null && _d !== void 0 ? _d : getDefaultLanguageDetectionPolicy()), languageDetectionPolicy = _k[0], setLanguageDetectionPolicy = _k[1];
    var checkIncludesLang = function (lang) { var _a, _b; return (_b = (_a = languageConf.enabled_language_codes) === null || _a === void 0 ? void 0 : _a.includes(lang)) !== null && _b !== void 0 ? _b : false; };
    var enabledLanguagesList = listLangs.filter(function (lang) { var _a; return (_a = languageConf.enabled_language_codes) === null || _a === void 0 ? void 0 : _a.includes(lang); });
    var onDefaultLanguageChange = function (lang) {
        var _a;
        setDefaultLanguage(lang);
        var updatedLanguageConf = __assign(__assign({}, languageConf), { default_language_code: lang });
        setLanguageConf(updatedLanguageConf);
        if (save) {
            save({
                settings: __assign(__assign({}, ((_a = record === null || record === void 0 ? void 0 : record.settings) !== null && _a !== void 0 ? _a : {})), { language_conf: updatedLanguageConf }),
            });
        }
    };
    var onLanguageDetectionPolicyChange = function (policy) {
        var _a;
        setLanguageDetectionPolicy(policy);
        var updatedLanguageConf = __assign(__assign({}, languageConf), { language_detection_policy: policy });
        setLanguageConf(updatedLanguageConf);
        if (save) {
            save({
                settings: __assign(__assign({}, ((_a = record === null || record === void 0 ? void 0 : record.settings) !== null && _a !== void 0 ? _a : {})), { language_conf: updatedLanguageConf }),
            });
        }
    };
    var handleToggle = function (lang) {
        var _a, _b;
        var includesLang = checkIncludesLang(lang);
        var currentLangs = (_a = languageConf.enabled_language_codes) !== null && _a !== void 0 ? _a : [];
        var enabledLangs = includesLang
            ? currentLangs.filter(function (code) { return code !== lang; })
            : __spreadArray(__spreadArray([], currentLangs, true), [lang], false);
        var updatedLanguageConf = __assign(__assign({}, languageConf), { enabled_language_codes: enabledLangs });
        setLanguageConf(updatedLanguageConf);
        if (save) {
            save({
                settings: __assign(__assign({}, ((_b = record === null || record === void 0 ? void 0 : record.settings) !== null && _b !== void 0 ? _b : {})), { language_conf: updatedLanguageConf }),
            });
        }
    };
    var logsTimeZone = ((_e = record === null || record === void 0 ? void 0 : record.settings) === null || _e === void 0 ? void 0 : _e.logs_timezone) || DEFAULT_TIME_ZONE;
    var onLogsTimeZoneChange = function (zone) {
        var _a;
        if (!zone || zone === logsTimeZone || !save)
            return;
        save({
            settings: __assign(__assign({}, ((_a = record === null || record === void 0 ? void 0 : record.settings) !== null && _a !== void 0 ? _a : {})), { logs_timezone: zone }),
        });
    };
    useEffect(function () {
        var _a, _b;
        if (record === null || record === void 0 ? void 0 : record.settings) {
            setLanguageConf((_b = (_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.language_conf) !== null && _b !== void 0 ? _b : defaultLanguageConf);
        }
    }, [record]);
    var languageDetectionPolicyOptions = Object.values(ELanguageDetectionPolicy).map(function (value) { return ({
        id: value,
        name: t("electionEventScreen.field.languageDetectionPolicy.options.".concat(value)),
    }); });
    if (isLoading)
        return null;
    return (_jsxs(SettingsLanguagesStyles.Wrapper, { children: [_jsx(Typography, { variant: "body2", paragraph: true, children: t("generalSettingsScreen.body") }), listLangs.map(function (lang) { return (_jsxs(SettingsLanguagesStyles.Content, { children: [_jsx(SettingsLanguagesStyles.Text, { children: t("language", { lng: lang }) }), _jsx(Switch, { checked: checkIncludesLang(lang), onChange: function () { return handleToggle(lang); } })] }, lang)); }), _jsxs(FormControl, { sx: { width: "30%" }, children: [_jsx(InputLabel, { id: "select-language", children: t("settings.languages.default") }), _jsx(Select, { labelId: "select-language", label: t("settings.languages.default"), value: defaultLanguage, onChange: function (event) { return onDefaultLanguageChange(event.target.value); }, fullWidth: true, children: enabledLanguagesList.map(function (lang) { return (_jsx(MenuItem, { value: lang, children: t("language", { lng: lang }) }, lang)); }) })] }, "select-language"), _jsxs(FormControl, { sx: { width: "30%" }, children: [_jsx(InputLabel, { id: "select-language-detection-policy", children: t("electionEventScreen.field.languageDetectionPolicy.policyLabel") }), _jsx(Select, { labelId: "select-language-detection-policy", fullWidth: true, label: t("electionEventScreen.field.languageDetectionPolicy.policyLabel"), value: languageDetectionPolicy, onChange: function (event) {
                            return onLanguageDetectionPolicyChange(event.target.value);
                        }, children: languageDetectionPolicyOptions.map(function (option) { return (_jsx(MenuItem, { value: option.id, children: option.name }, option.id)); }) })] }, "select-language-detection-policy"), _jsx(TimeZonePicker, { label: t("settings.languages.logsTimezone"), value: logsTimeZone, onChange: onLogsTimeZoneChange, sx: { width: { xs: "100%", md: "30%" }, minWidth: { md: 320 }, mt: 2 } })] }));
};
var templateObject_1, templateObject_2, templateObject_3;
